import React, { useEffect, useState } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import ListCategoriesOption from '../ListCategoriesOption';
import ListTagField from '../ListTagField';
import ListTagFieldItem from '../ListTagFieldItem';
import ListTicketMessage from '../ListTicketMessage';
import ConfirmMessage from '../ConfirmMessage';
import TheEndMessage from '../TheEndMessage';
import FreeMessage from '../FreeMessage';
import MessageLoadListTagField from '../MessageLoadListTagField';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import QAFormInChatbot from './QAFormInChatbot';
import QAFormOptionLiveChat from './QAFormOptionLiveChat';
import BackToBeginMessage from './BackToBeginMessage';
import DataFormQaAfterSubmit from './DataFormQaAfterSubmit';
import MessageConnectedLiveChat from '../MessageConnectedLiveChat';
import MessageTime from './MessageTime';
import UploadFileMessage from '../UploadFileMessage';
import LiveChatMessageFromMe from '../LiveChatMessageFromMe';
import MessageEndLiveChat from '../MessageEndLiveChat';
import LiveChatMention from '../LiveChatMention';
import { I18n } from 'aws-amplify';
import WaitingGPTResponseMessage from '@/component/chatAI/element/WaitingGPTResponseMessage';
import AIResponse from '@/component/chatAI/element/AIResponse';

export default function ChatBotListMessage({
    messages,
    chatbotSettings,
    handleClickFormOption,
    handleClickFieldOption,
    listCategories,
    setMessages,
    listTagFieldSelected,
    handleClickItemOption,
    supportThreadIdState,
    affiliationOrganization,
    filterPublicKnowledge,
    listSelectedItemOfSession,
    listTicketIdBeforeFilterTagField,
    setListKnowledgeTicketId,
    projectId,
    subDomain,
    scrollIntoViewMsg,
    messageRef,
    isModePreview,
    setListTagFieldOfSelectedCategory,
    setListTagFieldId,
    setFilterPublicKnowledge,
    setListSelectedItemOfSession,
    setListTagFieldSelected,
    setListTicketIdBeforeFilterTagField,
    listKnowledgeTicketId,
    handleWhenRenderTagFieldPriority,
    listTagFieldOfSelectedCategory,
    projectAlias,
    API,
    categoryIdSelected,
    formQASystem,
    isMaximizedPanel,
    setIsShowModalReload,
    setIsActivateLiveChat,
    setSupportTicketId,
    fileUploadList,
    fileUploading,
    sentMessageList,
    listAgentData,
    isIframeChatBot,
    projectInuseDetail,
    currentCorporationDetail,
    idOfResponseMessage,
    setIsEnableBtnSend,
    isEnableBtnSend,
    setQueryGetListKnowledgeBase,
    usingAI,
    listTagItemSelected,
    setIsEnableMsgInput,
    listTagFieldSkip,
    setListTagFieldSkip,
    enableListTicket
}) {
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);

    const [chatbotLogo, setChatBotLogo] = useState(
        isModePreview ? previewSetting.logo : chatbotSettings?.logo
    );
    const [chatBotName, setChatBotName] = useState(
        isModePreview ? previewSetting?.chatbotName : chatbotSettings?.chatbotName
    );
    const [formDataTransfer, setFormDataTransfer] = useState({});

    useEffect(() => {
        if (!isModePreview) {
            if (chatbotSettings.logo !== chatbotLogo) {
                setChatBotLogo(chatbotSettings.logo);
            }
            if (chatbotSettings.chatbotName !== chatBotName) {
                setChatBotName(chatbotSettings.chatbotName);
            }
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.logo !== chatbotLogo) {
                setChatBotLogo(previewSetting.logo);
            }
            if (previewSetting.chatbotName !== chatBotName) {
                setChatBotName(previewSetting.chatbotName);
            }
        }
    }, [previewSetting]);

    return (
        <div className="chat-messages" id="chatbot-msgbox" >
            {messages.map((message, index) => (
                <div
                    key={index}
                    className={`chat-message ${
                        message.isFromMe
                            ? 'from-me'
                            : isMaximizedPanel
                            ? 'from-them-maximized'
                            : 'from-them-minimized'
                    } `}
                >
                    <MessageTime
                        messages={messages}
                        message={message}
                        index={index}
                        chatbotLogo={chatbotLogo}
                        chatBotName={chatBotName}
                        listAgentData={listAgentData}
                        isModePreview={isModePreview}
                    />
                    {(() => {
                        switch (message.messageType) {
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE:
                                return (
                                    <div
                                        className={`${
                                            message.isError ? 'message-error' : 'message-text'
                                        }`}
                                    >
                                        {message.isLoadingMessage ? (
                                            <WaitingGPTResponseMessage
                                                setIsEnableBtnSend={setIsEnableBtnSend}
                                                isEnableBtnSend={isEnableBtnSend}
                                                setListMessageContent={setMessages}
                                                idOfResponseMessage ={idOfResponseMessage}
                                                scrollToBottom={scrollIntoViewMsg}
                                                isFromChatBot={true}
                                                categoryIdSelected={categoryIdSelected}
                                                formQASystem={formQASystem}
                                                supportThreadIdState={supportThreadIdState}
                                                affiliationOrganization={affiliationOrganization}
                                                usingAI={usingAI}
                                            />
                                        ) : (
                                            <AIResponse data={message} isPublicSite={true} />
                                        )}
                                    </div>
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM:
                                return (
                                    <ListCategoriesOption
                                        message={message}
                                        onClickHandler={handleClickFormOption}
                                        chatbotSettings={chatbotSettings}
                                        isModePreview={isModePreview}
                                        isMaximizedPanel={isMaximizedPanel}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_FIELD:
                                return (
                                    <ListTagField
                                        message={message}
                                        onClickHandler={handleClickFieldOption}
                                        chatbotSettings={chatbotSettings}
                                        listCategories={listCategories}
                                        setMessages={setMessages}
                                        messages={messages}
                                        listTagFieldSelected={listTagFieldSelected}
                                        isModePreview={isModePreview}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        isMaximizedPanel={isMaximizedPanel}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_ITEM:
                                return (
                                    <ListTagFieldItem
                                        message={message}
                                        onClickHandler={handleClickItemOption}
                                        chatbotSettings={chatbotSettings}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        listTagFieldSelected={listTagFieldSelected}
                                        messages={messages}
                                        setMessages={setMessages}
                                        filterPublicKnowledge={filterPublicKnowledge}
                                        listSelectedItemOfSession={listSelectedItemOfSession}
                                        listTicketIdBeforeFilter={listTicketIdBeforeFilterTagField}
                                        setListKnowledgeTicketId={setListKnowledgeTicketId}
                                        isModePreview={isModePreview}
                                        listCategories={listCategories}
                                        listTagFieldOfSelectedCategory={
                                            listTagFieldOfSelectedCategory
                                        }
                                        setListTicketIdBeforeFilterTagField={
                                            setListTicketIdBeforeFilterTagField
                                        }
                                        handleWhenRenderTagFieldPriority={
                                            handleWhenRenderTagFieldPriority
                                        }
                                        setListTagFieldSelected={setListTagFieldSelected}
                                        isMaximizedPanel={isMaximizedPanel}
                                        usingAI={usingAI}
                                        listTagItemSelected={listTagItemSelected}
                                        listTagFieldSkip={listTagFieldSkip}
                                        setListTagFieldSkip={setListTagFieldSkip}
                                        enableListTicket={enableListTicket}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TICKET:
                                return (
                                    <ListTicketMessage
                                        message={message}
                                        projectId={projectId}
                                        subDomain={subDomain}
                                        chatbotSettings={chatbotSettings}
                                        messages={messages}
                                        setMessages={setMessages}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        scrollIntoViewMsg={scrollIntoViewMsg}
                                        isModePreview={isModePreview}
                                        projectAlias={projectAlias}
                                        categoryIdSelected={categoryIdSelected}
                                        formQASystem={formQASystem}
                                        isMaximizedPanel={isMaximizedPanel}
                                        API={API}
                                        projectInuseDetail={projectInuseDetail}
                                        currentCorporationDetail={currentCorporationDetail}
                                        setIsEnableBtnSend={setIsEnableBtnSend}
                                        listTagFieldOfSelectedCategory={
                                            listTagFieldOfSelectedCategory
                                        }
                                        usingAI={usingAI}
                                        listCategories={listCategories}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONFIRM_ISSUES_RESOLVED:
                                return (
                                    <ConfirmMessage
                                        message={message}
                                        setMessages={setMessages}
                                        settingChatBot={chatbotSettings}
                                        messages={messages}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        isModePreview={isModePreview}
                                        setIsShowModalReload={setIsShowModalReload}
                                        projectAlias={projectAlias}
                                        subDomain={subDomain}
                                        listCategories={listCategories}
                                        isMaximizedPanel={isMaximizedPanel}
                                        projectId={projectId}
                                        isIframeChatBot={isIframeChatBot}
                                        projectInuseDetail={projectInuseDetail}
                                        currentCorporationDetail={currentCorporationDetail}
                                        isChatRobo={true}
                                        API={API}
                                        setIsEnableMsgInput={setIsEnableMsgInput}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.THE_END:
                                return (
                                    <TheEndMessage
                                        message={message}
                                        setMessages={setMessages}
                                        listCategories={listCategories}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        messages={messages}
                                        chatbotSetting={chatbotSettings}
                                        isModePreview={isModePreview}
                                        isMaximizedPanel={isMaximizedPanel}
                                        setIsEnableMsgInput={setIsEnableMsgInput}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN:
                                return (
                                    <BackToBeginMessage
                                        message={message}
                                        setMessages={setMessages}
                                        listCategories={listCategories}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        messages={messages}
                                        chatbotSetting={chatbotSettings}
                                        isModePreview={isModePreview}
                                        isMaximizedPanel={isMaximizedPanel}
                                        formQASystem={formQASystem}
                                        setIsEnableMsgInput={setIsEnableMsgInput}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE:
                                return (
                                    <FreeMessage
                                        message={message}
                                        isMaximizedPanel={isMaximizedPanel}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FORM_QA_IN_CHATBOT:
                                return (
                                    <QAFormInChatbot
                                        message={message}
                                        setMessages={setMessages}
                                        settingChatBot={chatbotSettings}
                                        messages={messages}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        isModePreview={isModePreview}
                                        listCategories={listCategories}
                                        API={API}
                                        categoryIdSelected={categoryIdSelected}
                                        projectId={projectId}
                                        setFormDataTransfer={setFormDataTransfer}
                                        formDataTransfer={formDataTransfer}
                                        isMaximizedPanel={isMaximizedPanel}
                                        projectAlias={projectAlias}
                                        subDomain={subDomain}
                                        setIsShowModalReload={setIsShowModalReload}
                                        isIframeChatBot={isIframeChatBot}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.QA_FORM_OPTION_LIVE_CHAT:
                                return (
                                    <QAFormOptionLiveChat
                                        message={message}
                                        setMessages={setMessages}
                                        settingChatBot={chatbotSettings}
                                        messages={messages}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        isModePreview={isModePreview}
                                        listCategories={listCategories}
                                        API={API}
                                        categoryIdSelected={categoryIdSelected}
                                        projectId={projectId}
                                        setFormDataTransfer={setFormDataTransfer}
                                        formDataTransfer={formDataTransfer}
                                        isMaximizedPanel={isMaximizedPanel}
                                        projectAlias={projectAlias}
                                        subDomain={subDomain}
                                        setIsShowModalReload={setIsShowModalReload}
                                        setIsActivateLiveChat={setIsActivateLiveChat}
                                        setSupportTicketId={setSupportTicketId}
                                        isIframeChatBot={isIframeChatBot}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONTENT_QA_CHATBOT:
                                return (
                                    <DataFormQaAfterSubmit
                                        message={message}
                                        setMessages={setMessages}
                                        settingChatBot={chatbotSettings}
                                        messages={messages}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        isModePreview={isModePreview}
                                        listCategories={listCategories}
                                        API={API}
                                        categoryIdSelected={categoryIdSelected}
                                        projectId={projectId}
                                        setFormDataTransfer={setFormDataTransfer}
                                        formDataTransfer={formDataTransfer}
                                        isMaximizedPanel={isMaximizedPanel}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LOADING_GET_LIST_TAG_FIELD:
                                return (
                                    <MessageLoadListTagField
                                        message={message}
                                        onClickHandler={handleClickItemOption}
                                        chatbotSettings={chatbotSettings}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        listTagFieldSelected={listTagFieldSelected}
                                        messages={messages}
                                        setMessages={setMessages}
                                        filterPublicKnowledge={filterPublicKnowledge}
                                        listSelectedItemOfSession={listSelectedItemOfSession}
                                        listTicketIdBeforeFilter={listTicketIdBeforeFilterTagField}
                                        setListKnowledgeTicketId={setListKnowledgeTicketId}
                                        isModePreview={isModePreview}
                                        listCategories={listCategories}
                                        projectId={projectId}
                                        subDomain={subDomain}
                                        setListTagFieldOfSelectedCategory={
                                            setListTagFieldOfSelectedCategory
                                        }
                                        setListTagFieldId={setListTagFieldId}
                                        setFilterPublicKnowledge={setFilterPublicKnowledge}
                                        setListSelectedItemOfSession={setListSelectedItemOfSession}
                                        setListTagFieldSelected={setListTagFieldSelected}
                                        setListTicketIdBeforeFilterTagField={
                                            setListTicketIdBeforeFilterTagField
                                        }
                                        listKnowledgeTicketId={listKnowledgeTicketId}
                                        handleWhenRenderTagFieldPriority={
                                            handleWhenRenderTagFieldPriority
                                        }
                                        isMaximizedPanel={isMaximizedPanel}
                                        projectAlias={projectAlias}
                                        setIsShowModalReload={setIsShowModalReload}
                                        setQueryGetListKnowledgeBase={setQueryGetListKnowledgeBase}
                                        usingAI={usingAI}
                                        listTagItemSelected={listTagItemSelected}
                                        listTagFieldSkip={listTagFieldSkip}
                                        enableListTicket={enableListTicket}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONNECTED:
                                return (
                                    <MessageConnectedLiveChat
                                        message={message}
                                        setMessages={setMessages}
                                        listCategories={listCategories}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        messages={messages}
                                        chatbotSetting={chatbotSettings}
                                        isModePreview={isModePreview}
                                        isMaximizedPanel={isMaximizedPanel}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FILE_UPLOADED:
                                if (
                                    message.status === Constant.CHAT_POST_STATUS.DELETE ||
                                    message.status === Constant.CHAT_POST_STATUS.DELETE_READ
                                ) {
                                    return (
                                        <div className="message-text">
                                            <span style={{ opacity: 0.5 }}>
                                                {I18n.get('MSG_DELETED')}
                                            </span>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <UploadFileMessage
                                            message={message}
                                            isModePreview={isModePreview}
                                            fileUploadList={fileUploadList}
                                            fileUploading={fileUploading}
                                        />
                                    );
                                }
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.NOT_FOUND_AGENT:
                                return (
                                    <MessageConnectedLiveChat
                                        message={message}
                                        setMessages={setMessages}
                                        listCategories={listCategories}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        messages={messages}
                                        chatbotSetting={chatbotSettings}
                                        isModePreview={isModePreview}
                                        isMaximizedPanel={isMaximizedPanel}
                                        formQASystem={formQASystem}
                                        setIsEnableMsgInput={setIsEnableMsgInput}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN_AFTER_REJECT:
                                return (
                                    <BackToBeginMessage
                                        message={message}
                                        setMessages={setMessages}
                                        listCategories={listCategories}
                                        supportThreadIdState={supportThreadIdState}
                                        affiliationOrganization={affiliationOrganization}
                                        messages={messages}
                                        chatbotSetting={chatbotSettings}
                                        isModePreview={isModePreview}
                                        isMaximizedPanel={isMaximizedPanel}
                                        formQASystem={formQASystem}
                                        setIsEnableMsgInput={setIsEnableMsgInput}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_FORM_ME:
                                return (
                                    <LiveChatMessageFromMe
                                        message={message}
                                        sentMessageList={sentMessageList}
                                        isModePreview={isModePreview}
                                    />
                                );
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_MENTION:
                                if (
                                    message.status === Constant.CHAT_POST_STATUS.DELETE ||
                                    message.status === Constant.CHAT_POST_STATUS.DELETE_READ
                                ) {
                                    return (
                                        <div className="message-text">
                                            <span style={{ opacity: 0.5 }}>
                                                {I18n.get('MSG_DELETED')}
                                            </span>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <LiveChatMention
                                            message={message}
                                            listAgentData={listAgentData}
                                        />
                                    );
                                }
                            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT:
                                return (
                                    <MessageEndLiveChat
                                        message={message}
                                        chatbotSetting={chatbotSettings}
                                        isModePreview={isModePreview}
                                    />
                                );
                            default:
                                return message.status === Constant.CHAT_POST_STATUS.DELETE ||
                                    message.status === Constant.CHAT_POST_STATUS.DELETE_READ ? (
                                    <div className="message-text">
                                        <span style={{ opacity: 0.5 }}>
                                            {I18n.get('MSG_DELETED')}
                                        </span>
                                    </div>
                                ) : (
                                    <div
                                        className="message-text"
                                        dangerouslySetInnerHTML={{
                                            __html: Utils.replaceUrls(
                                                Utils.escapeHtmlCharacters(message.content),
                                                false,
                                                true,
                                                message.isFromMe ? 'color-white' : ''
                                            )
                                        }}
                                    ></div>
                                );
                        }
                    })()}
                </div>
            ))}

            {/* div using for scroll to bottom  */}
            {messages.length > 0 && (<div ref={messageRef}></div>)}
        </div>
    );
}
